import { toMomentFromUtc, apiMap, toUTCfromMoment } from 'api/helpers';
import { HOURS_RANGE } from 'config/constants';
import { API_DATE_FORMAT_WITH_TIME } from 'config/api';
import moment from 'moment';
import he from 'he';

@apiMap('api_map')
export default class PartNumberItem {
	count = 0;
	items = [];

	static api_map = {
		date: 'OrderDate',
		po_number: 'PoNumber',
		part: 'ItemNumber',
		description: 'Description',
		ordered_qty: 'QuantityOrdered',
		est_ship_date: 'PlanDeliveryDate',
		unit_price: 'UnitPrice',
		extended_price: 'ExtPrice',
	};

	checkDate(plannedDeliveryDate) {
		const plannedDeliveryDateInitial = moment(
			plannedDeliveryDate,
			API_DATE_FORMAT_WITH_TIME
		);

		const currentDateLocal = moment.utc();

		const offset = moment().utcOffset();
		const currentDateUTC = toUTCfromMoment(currentDateLocal, offset);

		const currentDateUTCFormat = moment(
			currentDateUTC,
			API_DATE_FORMAT_WITH_TIME
		);

		const differenceHours = plannedDeliveryDateInitial.diff(
			currentDateUTCFormat,
			'hours'
		);

		if (differenceHours < HOURS_RANGE) {
			return currentDateLocal.local();
		}
		return plannedDeliveryDateInitial;
	}

	constructor(orders) {
		this.count = orders.TotalCount;
		this.items = orders.PartNumbers.map(order => this.normalizeOrder(order));
	}

	normalizeOrder(order) {
		return {
			date: toMomentFromUtc(PartNumberItem.getApiValue('date', order)),
			po_number: PartNumberItem.getApiValue('po_number', order),
			part: PartNumberItem.getApiValue('part', order),
			description: he.decode(PartNumberItem.getApiValue('description', order)),
			ordered_qty: PartNumberItem.getApiValue('ordered_qty', order),
			est_ship_date: this.checkDate(
				PartNumberItem.getApiValue('est_ship_date', order)
			),
			unit_price: PartNumberItem.getApiValue('unit_price', order),
			extended_price: PartNumberItem.getApiValue('extended_price', order),
		};
	}
}



// WEBPACK FOOTER //
// ./src/api/models/PartNumberItem.js